import {InputNumber} from "primereact/inputnumber";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {selectAssociatedOutputParamOutputCurried} from "../../redux/objectParametersSelectors";
import InputNumberConflictOptions from "./InputNumberConflictOptions";
import ParameterFieldContainer from "./ParameterFieldContainer";
import {getResourceColor, useInputParameterDef} from "./paramHooks";

export default function ParameterInputYear({
    parameter,
    parameterType,
    label,
    id,
    parameter_details_def,
    associatedOutputParam,
}) {
    const {t} = useTranslation();
    const parameterData = useInputParameterDef(parameter, parameter_details_def);
    const associatedOutputParamValue = useSelector(selectAssociatedOutputParamOutputCurried(associatedOutputParam));

    const hasAssociatedOutput = associatedOutputParamValue !== undefined && associatedOutputParamValue !== null;

    let placeholder = hasAssociatedOutput
        ? `${t("object.associatedOutputParamPrefix")} ${associatedOutputParamValue}`
        : parameterData?.maxValue
          ? `max. ${parameterData.maxValue}`
          : null;

    return (
        <ParameterFieldContainer
            id={id}
            label={label}
            parameter={parameter}
            parameterType={parameterType}
            parameter_details_def={parameter_details_def}
            showDescription
            hasAssociatedOutputParam={!!associatedOutputParam}
            associatedOutputParamValue={associatedOutputParamValue}
            renderControl={({className, onChange, value, activeParameterType, hasConflict, disabled, allValues}) => {
                const color = getResourceColor(activeParameterType, hasConflict);
                const filledClass = hasAssociatedOutput ? `indication-filled-placeholder` : "";
                const conflictClassName = hasConflict ? `border-l-0 border-${color}` : "";
                const emptyString = t("object.valueTooltip.revaEmpty");
                placeholder = allValues?.reva === "empty" || value === "empty" ? emptyString : placeholder;

                return (
                    <>
                        <InputNumberConflictOptions
                            {...{allValues, hasConflict, onChange, emptyString}}
                            className={`${color} ${parameter}`}
                        />
                        <InputNumber
                            inputId={id}
                            value={typeof value === "number" ? value : null}
                            disabled={disabled}
                            placeholder={placeholder}
                            onValueChange={onChange}
                            onBlur={(e) => {
                                if (e.target.value === "" && typeof value === "number") e.target.value = value;
                            }}
                            useGrouping={false}
                            inputClassName={`text-right text-${color} ${className} ${parameter} ${filledClass} ${conflictClassName}`}
                            data-pr-position="top"
                        />
                    </>
                );
            }}
        />
    );
}
